import isEmpty from "lodash/isEmpty";
export var orderIsFreeDutiesEligible = function orderIsFreeDutiesEligible(brandOrder) {
  var free_duties_reason = brandOrder.free_duties_reason;
  return !isEmpty(free_duties_reason);
};